module.exports = __webpack_public_path__ + "static/media/en_CO2.372a54f4.svg";